import { Html } from "@react-three/drei";
import { Fragment, useEffect, useState } from "react";
import { useStore } from "../Store/zustandStore";
import { HTML_OVERLAY_Z_INDEX_RANGE } from "../Utils/overlayConstants";
import {
  calculateBounds,
  fromMM,
  getFramesFromScene,
  toMM,
} from "../Utils/frameUtils";
import {
  collectDimensionables,
  calculateDimensions,
} from "../Utils/dimensionUtils";
import { COMPONENT_ALIGNMENT } from "../Constants";

export default function Dimensions({ frames, enabled, dimensionSide }) {
  const [frameThickness] = useStore((state) => [state.frameThickness]);
  const sectionIds = !frames
    ? []
    : [
        ...new Set(
          frames.filter((f) => f.sectionId != null).map((f) => f.sectionId),
        ),
      ];

  return enabled && frames?.length > 0 ? (
    <group userData={{ type: "dimensions" }}>
      <Dimension
        key="unit-length"
        frames={frames}
        allFrames={frames}
        offsetHorizontal={0.3}
        offsetVertical={0.25}
        frameThickness={frameThickness}
        dimensionSide={dimensionSide}
        baseFrameHeight={fromMM(100)}
        isTotal={true}
        sectionViews={{
          "3d": {
            visibleAxes: ["x1", "y1"],
            levels: [2, 3, 1],
            alignments: {
              length: COMPONENT_ALIGNMENT.BOTTOM,
            },
          },
          "2d": {
            visibleAxes: ["x1"],
            levels: [2, 2],
            alignments: {
              length: COMPONENT_ALIGNMENT.BOTTOM,
            },
          },
        }}
      ></Dimension>
        <Dimension
          key="section-length"
          frames={frames.filter((f) => !f.isExterior)}
          allFrames={frames}
          offsetHorizontal={0.1}
          offsetVertical={0.12}
          frameThickness={frameThickness}
          dimensionSide={dimensionSide}
          sectionViews={{
            "3d": {
              visibleAxes: frames.includes((f) => f.isExterior) ? ["x1", "y1"] : ["y1"],
              levels: [1, 2, 1],
            },
            "2d": {
              visibleAxes: ["x1"],
              levels: [2, 3],
            },
          }}
        ></Dimension>
      )
      

      {frames
        .filter((f) => !f.sectionId)
        .map((f) => {
          //  return <Dimension key={f.id} frames={[f]} offsetHorizontal={0.25} offsetVertical={0.25} frameThickness={frameThickness} dimensionSide={dimensionSide}></Dimension>;
          return (
            <Dimension
              key={f.id}
              frames={[f]}
              allFrames={frames}
              frameThickness={frameThickness}
              dimensionSide={dimensionSide}
            ></Dimension>
          );
        })}
      {sectionIds.map((sectionId) => {
        return (
          <Dimension
            key={sectionId}
            frames={frames.filter((f) => f.sectionId == sectionId)}
            allFrames={frames}
            frameThickness={frameThickness}
            dimensionSide={dimensionSide}
            sectionViews={{
              "3d": {
                visibleAxes: ["x"],
                levels: [1, 1, 1],
              },
              "2d": {
                visibleAxes: ["x1"],
                levels: [2, 2],
              },
            }}
          ></Dimension>
          // <Dimension
          //   key={sectionId}
          //   frames={frames.filter((f) => f.sectionId == sectionId)}
          //   offsetHorizontal={0.25}
          //   offsetVertical={0.25}
          //   frameThickness={frameThickness}
          //   dimensionSide={dimensionSide}
          // ></Dimension>
        );
      })}
    </group>
  ) : null;
}

// function Dimension({ frames, frameThickness, dimensionSide, isTotal = false, offsetHorizontal = 0.25, offsetVertical = 0.25 }) {
//   const [positionAndSizes, setPositionAndSizes] = useState();
//   const multiplier = 200;

//   useEffect(() => {
//     if (!frames || frames.length == 0) return;
//     setPositionAndSizes(calculateDimensions(frames, frameThickness, offsetHorizontal, offsetVertical, dimensionSide, isTotal));
//   }, [frames, dimensionSide]);

//   return (
//     <group userData={{ type: "dimensions" }}>
//       {positionAndSizes
//         ?.filter((d) => d.lengthPosition || d.heightPosition || d.widthPosition)
//         .map((positionAndSize, i) => (
//           <Fragment key={`dimension-${i}`}>
//             {positionAndSize.showLength && (
//               <>
//                 <DimensionObjects position={positionAndSize.lengthPosition} rotation={[0, 0, Math.PI / 2]} length={positionAndSize.lengthSize} />
//                 <Html position={positionAndSize.lengthPosition} center>
//                   <div
//                     className="dimension-length"
//                     style={{
//                       width: positionAndSize.lengthSize * multiplier,
//                     }}
//                   >
//                     <div>
//                       <span>{positionAndSize.lengthSizeMM}</span>
//                     </div>
//                   </div>
//                 </Html>
//               </>
//             )}
//             {positionAndSize.showHeight && (
//               <>
//                 <DimensionObjects position={[ positionAndSize.heightPosition[0] * 1.1, positionAndSize.heightPosition[1],positionAndSize.heightPosition[2]]} rotation={[0, 0, 0]} length={positionAndSize.heightSize} />
//                 <Html position={[ positionAndSize.heightPosition[0] * 1.1, positionAndSize.heightPosition[1],positionAndSize.heightPosition[2]]} center>
//                   <div className="dimension-height" style={{ height: positionAndSize.heightSize * multiplier }}>
//                     <div>
//                       <span>{positionAndSize.heightSizeMM}</span>
//                     </div>
//                   </div>
//                 </Html>
//                 {i == 0 && (
//                   <>
//                     <DimensionObjects
//                       position={[positionAndSize.heightPosition[0], positionAndSize.heightPosition[1] - fromMM(50), positionAndSize.heightPosition[2]]}
//                       rotation={[0, 0, 0]}
//                       length={positionAndSize.heightSize + fromMM(100)}
//                     />
//                     <Html position={positionAndSize.heightPosition} center>
//                       <div className="dimension-height" style={{ height: (positionAndSize.heightSize + fromMM(100)) * multiplier }}>
//                         <div>
//                           <span>{positionAndSize.heightSizeMM + 100}</span>
//                         </div>
//                       </div>
//                     </Html>
//                   </>
//                 )}
//               </>
//             )}
//             {positionAndSize.showWidth && (
//               <>
//                 <DimensionObjects position={positionAndSize.widthPosition} rotation={[Math.PI / 2, 0, 0]} length={positionAndSize.widthSize} />
//                 <Html position={positionAndSize.widthPosition} rotation-y={-Math.PI / 2} center>
//                   <div className="dimension-width" style={{ width: positionAndSize.widthSize * multiplier, fontSize: "14px" }}>
//                     <div>
//                       <span>{positionAndSize.widthSizeMM}</span>
//                     </div>
//                   </div>
//                 </Html>
//               </>
//             )}
//           </Fragment>
//         ))}
//     </group>
//   );
// }

function DimensionAxis({ axis, data }) {
  const pos = data.positions[axis];
  const len = data[axis];
  const label = data.type != "text" ? data[`${axis}MM`] : data.text;
  const multiplier = 200;
  const rotationMap = {
    length: [0, 0, Math.PI / 2],
    height: [0, 0, 0],
    width: [Math.PI / 2, 0, 0],
  };

  return (
    <>
      {data.type != "text" ? (
        <>
          <DimensionObjects
            position={pos}
            rotation={rotationMap[axis]}
            length={len}
          />
          <Html position={pos} center zIndexRange={HTML_OVERLAY_Z_INDEX_RANGE}>
            <div className={`dimension-${axis}`}>
              <div>
                <span>{label}</span>
              </div>
            </div>
          </Html>
        </>
      ) : (
        <Html position={pos} center zIndexRange={HTML_OVERLAY_Z_INDEX_RANGE}>
          <div className={`dimension-label`}>
            <div>
              <span>{label}</span>
            </div>
          </div>
        </Html>
      )}
    </>
  );
}

function Dimension({
  frames,
  allFrames,
  frameThickness,
  dimensionSide,
  offsetHorizontal = 0,
  offsetVertical = 0,
  baseFrameHeight,
  isTotal,
  sectionViews,
}) {
  const [dims, setDims] = useState([]);

  useEffect(() => {
    if (!frames || frames.length === 0) return;
    const dimensionables = collectDimensionables(      
      frames,
      allFrames,
      frameThickness,
      "3d",
      baseFrameHeight,
      isTotal,
      sectionViews,
      dimensionSide
    );
    setDims(
      calculateDimensions(
        dimensionables,
        dimensionSide,
        offsetHorizontal,
        offsetVertical,
      ),
    );
  }, [frames, dimensionSide]);

  return (
    <group userData={{ type: "dimensions" }}>
      {dims.map((d) => (
        <Fragment key={d.id}>
          {d.showLength && <DimensionAxis axis="length" data={d} />}
          {d.showHeight && <DimensionAxis axis="height" data={d} />}
          {d.showWidth && <DimensionAxis axis="width" data={d} />}
        </Fragment>
      ))}
    </group>
  );
}

function DimensionObjects({ position, rotation, length }) {
  const dimensionRadius = 0.005;
  return (
    <group position={position} rotation={rotation}>
      <mesh>
        <cylinderGeometry args={[dimensionRadius, dimensionRadius, length]} />
        <meshStandardMaterial color={"Black"} />
      </mesh>
      <mesh position={[0, -length / 2, 0]} rotation={[0, 0, -Math.PI / 2]}>
        <cylinderGeometry args={[dimensionRadius, dimensionRadius, 0.1]} />
        <meshStandardMaterial color={"Black"} />
      </mesh>
      <mesh position={[0, length / 2, 0]} rotation={[0, 0, -Math.PI / 2]}>
        <cylinderGeometry args={[dimensionRadius, dimensionRadius, 0.1]} />
        <meshStandardMaterial color={"Black"} />
      </mesh>
    </group>
  );
}
